import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { api } from "@/lib/api";

let offerCache = null;
export function useOffer() {
  const [offer, setOffer] = useState(offerCache);
  useEffect(() => {
    if (offerCache) return;
    api.get("/membership/plans").then(({ data }) => { offerCache = data.offer; setOffer(data.offer); }).catch(() => {});
  }, []);
  return offer;
}

function useCountdown(endsAt) {
  const [left, setLeft] = useState(0);
  useEffect(() => {
    const tick = () => setLeft(Math.max(0, new Date(endsAt) - new Date()));
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, [endsAt]);
  const s = Math.floor(left / 1000);
  return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
}

export const Countdown = ({ endsAt }) => {
  const t = useCountdown(endsAt);
  return (
    <div className="flex gap-2" data-testid="diwali-countdown">
      {[["Days", t.d], ["Hrs", t.h], ["Min", t.m], ["Sec", t.s]].map(([l, v]) => (
        <div key={l} className="min-w-[56px] rounded-xl bg-white/10 px-2 py-2 text-center text-white">
          <div className="font-display text-xl font-bold tabular-nums">{String(v).padStart(2, "0")}</div>
          <div className="text-[10px] uppercase tracking-widest opacity-70">{l}</div>
        </div>
      ))}
    </div>
  );
};

export const DiwaliBanner = ({ compact = false }) => {
  const offer = useOffer();
  if (!offer?.trial_active) return null;
  return (
    <div className="relative overflow-hidden rounded-2xl bg-tm-dark text-white tm-gold-glow" data-testid="diwali-banner">
      <img src="/images/diwali.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-35" />
      <div className="absolute inset-0 bg-gradient-to-r from-tm-dark via-tm-dark/85 to-transparent" />
      <div className={`relative ${compact ? "p-5" : "p-8 lg:p-10"}`}>
        <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-tm-saffron"><Sparkles className="h-4 w-4" />{offer.title}</p>
        <h3 className={`mt-2 font-display font-extrabold ${compact ? "text-xl" : "text-2xl sm:text-3xl"}`}>Free until {offer.deadline}</h3>
        {!compact && <p className="mt-2 max-w-lg text-sm text-white/75">{offer.note}</p>}
        <div className="mt-4"><Countdown endsAt={offer.deadline_iso} /></div>
        <Link to="/pricing" className="mt-5 inline-flex rounded-full bg-tm-saffron px-5 py-2.5 text-sm font-semibold text-tm-dark transition-transform duration-200 hover:scale-[1.03]" data-testid="diwali-claim-offer-button">See plans</Link>
      </div>
    </div>
  );
};
